module.exports = "/_next/static/images/697364932de83da66a468970a318ad6b-paper-icon.svg.webp";